<template>
  <v-container>
    <v-row class="text-center" v-show="loading">
      <v-progress-circular
        class="mx-auto loader"
        indeterminate
        color="orange"
        size="75"
      ></v-progress-circular>
    </v-row>

    <v-row v-show="!loading">
      <v-col cols="12" md="4">
        <SelectProfile @select="select"></SelectProfile>
      </v-col>
      <v-col cols="12" md="5">
        <v-text-field
          v-model="term"
          label="Search"
          append-icon="mdi-magnify"
          @input="search"
        ></v-text-field>
      </v-col>
      <v-col cols="12" md="3" class="text-right" v-show="profile">
        <v-btn class="mx-2" fab dark color="orange" @click="dialog = true">
          <v-icon dark>mdi-plus</v-icon>
        </v-btn>
      </v-col>
    </v-row>

    <v-row class="cards" v-show="!loading">
      <v-col cols="12" md="4" v-for="item in filtered" :key="item.id">
        <v-card height="450px">
          <v-carousel height="200" cycle show-arrows-on-hover hide-delimiters>
            <v-carousel-item v-for="(file, index) in item.media" :key="index">
              <v-sheet color="white" height="100%">
                <v-row class="fill-height">
                  <v-img :src="file" width="100%" position="top" />
                </v-row>
              </v-sheet>
            </v-carousel-item>
          </v-carousel>
          <v-card-title>
            {{ item.title }}
          </v-card-title>
          <v-card-subtitle>
            <p class="my-0">
              <span class="font-weight-bold">Date:</span>
              {{ formatDate(item.created) }}
            </p>
          </v-card-subtitle>
          <v-card-text>
            {{ item.body.substring(0, 150) }}
            <span v-show="item.body.length > 150">...</span>
          </v-card-text>
          <v-card-actions>
            <v-btn color="green" text @click="edit(item)">Edit</v-btn>
            <v-spacer></v-spacer>
            <v-btn class="btn-right" color="red" text @click="remove(item)"
              >Delete</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>

    <v-dialog v-model="dialog" max-width="600px">
      <v-card>
        <v-card-title class="dark-background white--text">
          Add/Edit Achievement
        </v-card-title>
        <v-card-text class="mt-6">
          <SelectProfile @select="p => (profile = p)"></SelectProfile>
          <v-file-input v-model="media" multiple label="Photos"></v-file-input>
          <v-text-field v-model="title" label="Title"></v-text-field>
          <v-textarea v-model="body" label="Description"></v-textarea>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="grey" @click="dialog = false">Cancel</v-btn>
          <v-btn text color="orange" @click="save">
            <v-progress-circular
              v-if="saving"
              indeterminate
              color="orange"
            ></v-progress-circular>
            <span v-else>Save</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar v-model="snackbar">
      {{ snackText }}
      <v-btn color="pink" text @click="snackbar = false">
        Close
      </v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
import moment from "moment";
import { mapActions, mapGetters } from "vuex";
import SelectProfile from "@/components/SelectProfile";

export default {
  name: "Achievements",
  components: { SelectProfile },
  data() {
    return {
      achievement: {},
      body: null,
      dialog: false,
      filtered: [],
      loading: true,
      media: [],
      profile: null,
      saving: false,
      snackbar: false,
      snackText: null,
      term: null,
      title: null
    };
  },
  computed: {
    ...mapGetters({
      achievements: "achievements/getAchievements",
      profiles: "profiles/getProfiles",
      user: "users/getUser"
    })
  },
  methods: {
    ...mapActions({
      initUser: "users/initUser",
      createAchievement: "achievements/createAchievement",
      createFile: "achievements/createFile",
      deleteAchievement: "achievements/deleteAchievement",
      listAchievements: "achievements/listAchievements",
      listMedia: "achievements/listMedia",
      updateAchievement: "achievements/updateAchievement"
    }),
    edit(item) {
      this.achievement = item;
      this.title = item.title;
      this.body = item.body;
      this.dialog = true;
    },
    formatDate(timestamp) {
      return moment(timestamp).format("LL");
    },
    async remove(item) {
      await this.deleteAchievement({
        achievement: item.id,
        profile: this.profile.id
      });
    },
    async save() {
      if (!this.title || !this.body) {
        this.snackbar = true;
        this.snackText = "The Title and Description fields are required";
        return;
      }
      this.saving = true;
      this.achievement.body = this.body;
      this.achievement.title = this.title;

      if (this.achievement.id) {
        await this.updateAchievement({
          data: this.achievement,
          achievement: this.achievement.id,
          profile: this.profile.id
        });
      } else {
        this.achievement.id = await this.createAchievement({
          data: {
            body: this.body,
            created: Date.now(),
            createdBy: this.user,
            media: this.media,
            title: this.title
          },
          profile: this.profile.id
        });
      }

      this.achievement = {};
      this.media = [];
      this.title = this.body = null;
      this.saving = false;
      this.dialog = false;
      this.select(this.profile);
    },
    search() {
      this.filtered = this.achievements.filter(n => {
        const term = this.term.toLowerCase();
        const body = n.body.toLowerCase();
        const title = n.title.toLowerCase();
        return title.includes(term) || body.includes(term);
      });
    },
    async select(profile) {
      this.loading = true;
      this.profile = profile;
      await this.listAchievements(this.profile.id);
      this.filtered = this.achievements.sort((a, b) => {
        return b.created - a.created;
      });
      this.term = null;
      this.loading = false;
    }
  },
  async mounted() {
    await this.initUser();
    this.loading = false;
  }
};
</script>

<style scoped>
.btn-right {
  position: absolute;
  left: 250px;
}
.cards .v-card__actions {
  position: absolute;
  bottom: 0px;
}
.loader {
  margin-top: 20%;
}
</style>
